import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ServiceOverview() {
  return <section data-section-id="226246" id="mobile-scaffold" className="relative bg-background text-foreground py-30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div className="lg:col-span-6 flex flex-col items-start">
            <Badge variant="default" className="mb-6 text-sm font-default font-semibold uppercase tracking-widest px-3 py-1 bg-primary text-primary-foreground">
              Plant Hire
            </Badge>
            
            <h1 className="font-default text-4xl md:text-5xl lg:text-[3.5rem] font-bold text-foreground leading-tight mb-6">
              Professional Mobile Scaffolding Solutions
            </h1>
            
            <p className="font-default text-lg font-normal text-foreground/80 leading-relaxed max-w-xl">
              Our high-strength aluminium mobile towers provide a safe and versatile platform for all your height-access requirements. Engineered for rapid assembly and easy manoeuvrability, our systems ensure maximum productivity while maintaining the highest safety standards on any Australian site.
            </p>

            <div className="mt-10">
              <Button asChild size="lg" className="h-14 px-8 text-base shadow-lg font-semibold uppercase tracking-wider">
                <Link to="https://set-starfish.10web.cloud/contact/">
                  Enquire Now
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="lg:col-span-6">
            <div className="relative border border-border overflow-hidden shadow-md">
              <img src="https://bottomupprojects.com.au/wp-content/uploads/2026/06/istockphoto-495732240-612x612-1.jpg" data-wvc-srcset="https://bottomupprojects.com.au/wp-content/uploads/2026/06/istockphoto-495732240-612x612-1.jpg-wvc-srcset" data-wvc-sizes="https://bottomupprojects.com.au/wp-content/uploads/2026/06/istockphoto-495732240-612x612-1.jpg-wvc-sizes" alt="Mobile scaffolding tower installation on-site" className="w-full h-auto object-cover aspect-[4/3] sm:aspect-video lg:aspect-[4/3]" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/10 pointer-events-none mix-blend-multiply"></div>
            </div>
          </div>
          
        </div>
      </div>

      {}
      <Separator className="absolute bottom-0 left-0 w-full bg-border" />
    </section>;
}